import { EventType } from "./eventType";

export class MahnungAuditDto {
	public auditId: number = 0;
	public createdAt: Date = new Date();
	public mahnungId: number = 0;
	public note: string = "";
	public email: string = "";
	public eventType: EventType = EventType.MahnungCalledCustomer;
}
